module.exports = __webpack_public_path__ + "static/media/GracelingJacket.f78fee7a.jpg";